<template>
  <a-card class="user-edit-page">
    <template slot="title">
      <div style="display: flex;justify-content: space-between">
        <div>{{ $t('staffEdit') }}</div>
        <dol-button @click="$router.go(-1)"><a-icon type="close" /></dol-button>
      </div>
    </template>
    <dol-form-model class="dol-edit-form" style="width: 50%" :model="editForm" :rules="validateRules" ref="editForm">
      <div style="text-align: center;margin: 20px 0;font-size: 24px;font-weight: 700;">{{ $t('employeeInformationEditing') }}</div>

      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('staffName')" prop="USER_NAME">
        <a-input v-model.trim="editForm.USER_NAME" :placeholder="$t('pleaseEnterTheEmployeeName')"/>
      </a-form-model-item>
      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('role')" prop="USER_ROLE">
        <dol-select
            v-model.trim="editForm.USER_ROLE"
            source="server"
            server-type="DotNet"
            dot-net-table-name="GM_ROLE"
            :label-field="$kt('ROLE_NAME')"
            key-field="ROLE_NAME"
            value-field="ROLE_ID"
            :query-data="$api.role['external_Not10000005']"
            mode="multiple"
        />
      </a-form-model-item>
<!--      <a-form-model-item label="用户名" prop="USER_CODE">
        <a-input v-model.trim="editForm.USER_CODE"/>
      </a-form-model-item>-->
<!--      <a-form-model-item label="密码" prop="PASSWORD">
        <a-input v-model.trim="editForm.PASSWORD"/>
      </a-form-model-item>-->
      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('mobile')" prop="MOBILE">
        <a-input v-model.trim="editForm.MOBILE" :placeholder="$t('pleaseEnterMobilePhoneNumber')"/>
      </a-form-model-item>
      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('email')"  prop="EMAIL">
        <a-input v-model.trim="editForm.EMAIL" :placeholder="$t('pleaseEnterEmailAddress')" />
      </a-form-model-item>
      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('password')"  prop="EMAIL">
        <a-input v-model.trim="editForm.PASSWORD" :placeholder="$t('pleaseFillInThePassword')" />
      </a-form-model-item>
      <div style="text-align: center">
        <a-button style="width: 160px;
          height: 40px;
          background: #1F6CBA;
          border-radius: 2px;
          color: #FFFFFF;" type="primary" @click="addUser">{{ $t('submit') }}</a-button>
      </div>

    </dol-form-model>
  </a-card>
</template>

<script>
export default {
  name: "userEdit",
  data() {
    return {
      editForm: {
        USER_ROLE: []
      },
      validateRules: {
        USER_NAME: [{ required: true, message: this.$t('pleaseFillInYourName'), trigger: 'blur' }],
        MOBILE: [
            { required: true, message: this.$t('pleaseEnterMobilePhoneNumber'), trigger: 'blur' },
            /*{ validator: (rule, value, callback) => {
              const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
              if (!reg.test(value) && value) {
                callback(this.$t('pleaseEnterTheCorrectMobilePhoneNumber'))
              }else {
                callback()
              }
            }
          }*/
          ],
        USER_CODE: [{ required: true, message: this.$t('pleaseFillInTheUserName'), trigger: 'blur' }],
        EMAIL: [{required: true, message: this.$t('pleaseFillInTheEmail'), trigger: 'blur'}],
        USER_ROLE: [
          { required: true, message:this.$t('pleaseSelectARole'), trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    addUser(){
      this.$refs.editForm.validate((val) =>{
        if(val){
          let condition = {
            LIST:[
              {
                "USER_ID":this.editForm.USER_ID,
                "USER_NAME":this.editForm.USER_NAME,
                "USER_CODE":this.editForm.EMAIL,
                "MOBILE":this.editForm.MOBILE,
                "STATUS":1,
                "COMPANY_ID":this.$store.state.userInfo.COMPANY_ID,
                "EMAIL": this.editForm.EMAIL,
                "SYS_TYPE":"20011003",
                PASSWORD: this.editForm.PASSWORD
              }
            ],
            ROLELIST:[]
          }
          let list=[]
          if (this.roleList) {
            this.roleList.forEach(item => {
              list.push({
                ROLE_ID: item,
                IS_CHECK: 0
              })
            })
          }
          this.editForm?.USER_ROLE?.forEach(item => {
            let result = list.findIndex((v) => {
              return v.ROLE_ID === item
            })
            if (result > 0) {
              list[result].IS_CHECK = 1
            } else {
              list.push({
                ROLE_ID: item,
                IS_CHECK: 1
              })
            }
          })
          condition.ROLELIST = list
          this.$h5Api({
            type: '2012',
            data: [condition],
            showMessage: false,
          }).then(data => {
            this.$message.info(this.$t('operateSuccessfully'))
            this.$router.replace('/company/user')
          }).catch(e => {
            this.$message.info(this.$t(e.status))
          })
        }
      })
    }
  },
  created() {
    if (this.$route.query.user) {
      this.editForm = this.$route.query.user;
      this.roleList = this.$route.query.user.USER_ROLE
    }
  }
}
</script>

<style lang="scss">
.user-edit-page {
  .ant-card-body {
    display: flex;
    justify-content: center;
  }
}

</style>